import { DateTime } from "luxon";

const PATTERNS: { regex: RegExp; format: string }[] = [
  { regex: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(\d{4})$/, format: "M/d/yyyy" },
  { regex: /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/(\d{2})$/, format: "M/d/yy" },
];

// A date typed into a roster. Two-digit years land in this century, except a
// birth date that would then be in the future, which goes back a century.
export const parseRosterDate = (
  text: string | null | undefined,
  { birthDate = false }: { birthDate?: boolean } = {}
): DateTime | null => {
  const value = (text ?? "").trim();

  for (const { regex, format } of PATTERNS) {
    const match = value.match(regex);
    if (!match) continue;

    let parsed = DateTime.fromFormat(value, format);

    if (format === "M/d/yy") {
      const thisYear = DateTime.now().year;
      let year = Math.floor(thisYear / 100) * 100 + parseInt(match[3], 10);
      if (birthDate && year > thisYear) year -= 100;
      parsed = DateTime.fromObject({ year, month: parsed.month, day: parsed.day });
    }

    if (!parsed.isValid) return null;
    if (birthDate && parsed > DateTime.now()) return null;

    return parsed;
  }

  return null;
};
